module.exports = __webpack_public_path__ + "img/source05_07.290c6922.png";